export const darkColors = {
  // Brand colors (keep consistent)
  primary: '#f86400',
  primaryDark: '#d95700',
  primaryLight: '#fa8c40',

  primary50: '#fff7ed',
  primary100: '#ffedd5',
  primary200: '#fed7aa',
  primary300: '#fdba74',
  primary400: '#fb923c',
  primary500: '#fa8c40',
  primary600: '#f86400',
  primary700: '#d95700',
  primary800: '#b34700',
  primary900: '#7c3200',

  // Secondary
  secondary: '#A855F7',
  secondaryDark: '#9333EA',

  // Neutrals (inverted for dark mode)
  dark: '#f8fafc',
  light: '#0f172a',
  gray0: '#0f172a',
  gray100: '#1e293b',
  gray200: '#334155',
  gray300: '#475569',
  gray400: '#64748b',
  gray500: '#94a3b8',
  gray600: '#cbd5e1',
  gray700: '#e2e8f0',
  gray800: '#f1f5f9',
  gray900: '#f8fafc',

  // Status (keep visible in dark mode)
  success: '#22c55e',
  successLight: '#86efac',
  successDark: '#15803d',
  warning: '#fbbf24',
  warningLight: '#fde68a',
  warningDark: '#b45309',
  error: '#ef4444',
  errorLight: '#fca5a5',
  errorDark: '#991b1b',
  danger: '#ef4444',
  dangerDark: '#dc2626',
  info: '#3b82f6',
  infoLight: '#93c5fd',
  infoDark: '#1e40af',

  // Background
  background: '#0f172a',
  surface: '#1e293b',
  surfaceHover: '#25324a',

  // Borders
  border: '#334155',
  borderSubtle: '#1e293b',
  borderStrong: '#475569',

  // Text
  text: '#f8fafc',
  textPrimary: '#f8fafc',
  textSecondary: '#cbd5e1',
  textMuted: '#94a3b8',
  textDisabled: '#64748b',
  textAccent: '#cbd5e1',

  // Accent
  accent: '#334155',
};
